import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4093754d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new_game" }
const _hoisted_2 = { class: "rules_game" }

import { useRouter } from 'vue-router';
import {restartGame} from '../composables/RestartGame'


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationGame',
  setup(__props) {

const router = useRouter()

function goHome() {
  router.push('/')
  restartGame()
}

function rulesGamePage() {
  router.push('/rules')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", {
        class: "nav_item",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (goHome()))
      }, " Новая игра ")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", {
        class: "nav_item",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (rulesGamePage()))
      }, " Правила игры ")
    ])
  ], 64))
}
}

})